import { Component, computed, inject, Signal } from '@angular/core';
import { IconComponent, Membership, SchemaMembershipStateService, SchemaUiService, UserDropdownComponent, UserStateService, SensorListCard } from '@net3-multiplatform-client/libs';
import { AuthService } from '../auth/services/auth.service';
import { HomeBase } from 'libs/features/home/home.base';

@Component({
  selector: 'app-home',
  imports: [UserDropdownComponent, IconComponent, SensorListCard],
  templateUrl: './home.component.html',
})
export class Home extends HomeBase {

  private userState = inject(UserStateService);
  private authService = inject(AuthService);
  private schemaState = inject(SchemaMembershipStateService);
  private schemaUIService = inject(SchemaUiService);

  user = this.userState.user;
  membership: Signal<Membership | null> = this.schemaState.schema;
  schemaProperties = this.schemaState.properties;

  showButtonBack = computed(() => {
    if (!this.user()) return false;
    return this.user()!.memberships.length > 1;
  });

  onSignOut() {
    this.authService.logout();
  }

  getShortSchemaName(schemaName: string) {
    return this.schemaUIService.getShortSchemaName(schemaName);
  }

}
